import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {CampaignMetric} from 'common/src/modules/analytics/analytics.types';
import {
  CampaignsStepsInformation,
  SlimCampaign,
} from 'common/src/modules/campaigns/campaigns.types';
import {CampaignsLibraryState} from './campaignsLibrary.types';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

const initialState: CampaignsLibraryState = {
  campaigns: [],
  campaignsMetrics: [],
  selectedCampaignIds: [],
  aiFilter: {
    aiFilteredIds: [],
    query: '',
  },
  campaignStepsInformation: {},
};

const campaignsLibrarySlice = createSlice({
  name: BreadcrumbName.CampaignsLibrary,
  initialState,
  reducers: {
    setCampaigns: (state, action: PayloadAction<SlimCampaign[]>) => {
      state.campaigns = action.payload;
    },
    setCampaignStepsInformation: (
      state,
      action: PayloadAction<Record<number, CampaignsStepsInformation>>,
    ) => {
      state.campaignStepsInformation = {...state.campaignStepsInformation, ...action.payload};
    },
    setCampaignMetrics: (state, action: PayloadAction<CampaignMetric[]>) => {
      state.campaignsMetrics = action.payload;
    },
    setAiCampaignsFilter: (
      state,
      action: PayloadAction<{aiFilteredIds: number[]; query: string}>,
    ) => {
      state.aiFilter = action.payload;
      state.selectedCampaignIds = [];
    },
    setSelectedCampaignIds: (state, action: PayloadAction<number[]>) => {
      state.selectedCampaignIds = action.payload;
    },
    unloadCampaignsLibrary: () => initialState,
  },
});

export const {
  setCampaigns,
  setCampaignStepsInformation,
  setCampaignMetrics,
  setAiCampaignsFilter,
  setSelectedCampaignIds,
  unloadCampaignsLibrary,
} = campaignsLibrarySlice.actions;

export default campaignsLibrarySlice.reducer;
